import useTransactionsStore from '@/store/modules/transactions';
import { defineComponent } from 'vue';
import { storeToRefs } from 'pinia';
import { numberFormat } from '@/utils/helpers';
import TransactHeader from '@/components/transact/TransactHeader.vue';
import TransactionDetailsComponent from '@/components/transaction/TransactionDetailsComponent.vue';
import router from '@/router';
export default defineComponent({
    name: 'TransactionDetails',
    components: {
        TransactHeader,
        TransactionDetailsComponent,
    },
    setup() {
        const transactionsStore = useTransactionsStore();
        const { selectedTransaction } = storeToRefs(transactionsStore);
        const fiatAmount = selectedTransaction.value?.transactionType === 'collection'
            ? numberFormat(selectedTransaction.value?.convertedAmount, 2, 2)
            : numberFormat((selectedTransaction.value?.convertedAmount ?? 0) -
                (selectedTransaction.value?.serviceFeeAmountLocal ?? 0) -
                (selectedTransaction.value?.partnerFeeAmountLocal ?? 0), 2, 2);
        const goBack = () => {
            router.push('/');
        };
        return {
            selectedTransaction,
            numberFormat,
            goBack,
            fiatAmount,
        };
    },
});
